/**
 * A column's checklist filter, opened from a small icon in its header. Stays
 * open while picking; the list and its keys are the shared checklist's.
 */

import React from 'react';
import { ChecklistPopover, useChecklist } from './checklist';
import type { HeaderFilterOption } from './types';

export const HeaderFilter: React.FC<{
  /** The icon the header shows; a single click on it opens the list. */
  iconTrigger: React.ReactNode;
  options: HeaderFilterOption[];
  value: readonly string[];
  onChange: (value: string[]) => void;
  ariaLabel: string;
}> = ({ iconTrigger, options, value, onChange, ariaLabel }) => {
  const checklist = useChecklist({ options, value, onChange });
  return (
    <ChecklistPopover
      checklist={checklist}
      trigger={
        <button
          ref={checklist.triggerRef}
          type='button'
          role='combobox'
          aria-expanded={checklist.open}
          aria-label={ariaLabel}
          className='group flex shrink-0 items-center rounded p-0.5 hover:bg-slate-200 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
        >
          {iconTrigger}
        </button>
      }
      contentClassName='w-56 rounded-sm p-0.5'
      sideOffset={4}
      ariaLabel={ariaLabel}
      variant='header'
    />
  );
};
